// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
// import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext"; //Store Custm Code
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
// import AddToCartOptionsAndButton, { // Store Custom Code
//    AddToCartOptionsAndButtonStyles, // Store Custom Code
// } from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton"; // Store Custom Code
import { productCardProps } from "@store/Themes/common/props/productCard";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import {
    HasProductContext,
    ProductContextModel,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import AddToCartOptionsAndButton, {
    AddToCartOptionsAndButtonStyles,
} from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton";
/* Store Custom Code - End */

interface OwnProps {
    showPrice: boolean;
    showAddToList: boolean;
    /* Store Custom Code - Start */
    isModalContext: boolean;
    /* Store Custom Code - End */
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> &
    HasProductContext &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps;

export interface ProductListActionsStyles {
    wrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss; // Starter Custom Code
    addToCartButton?: ButtonPresentationProps;
    quantityOrdered?: TextFieldProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    addToListLink?: ProductAddToListLinkStyles;
    addToListWrapper?: InjectableCss;
    // Starter Custom Code
    priceWrapper?: InjectableCss;
    addToCartOptionsAndButton?: AddToCartOptionsAndButtonStyles;
}

export const actionsStyles: ProductListActionsStyles = {
    wrapper: productCardProps.actionsWrapper,
    priceWrapper: productCardProps.spacingWrapper,
    price: productCardProps.price,
    quantityBreakPricing: productCardProps.quantityBreakPricing,
    addToCartOptionsAndButton: productCardProps.addToCartOptionsAndButton,
    addToListWrapper: productCardProps.addToListWrapper,
    addToListLink: productCardProps.addToListLink,
};

const styles = actionsStyles;

/* Store Custom Code - Start */
const getProductContextId = (productContext: ProductContextModel) => {
    const {
        product: { id },
    } = productContext;
    return id;
};
/* Store Custom Code - End */

const ProductListActions: FC<Props> = ({
    productContext,
    productSettings,
    showPrice,
    showAddToList,
    // Store Custom Code
    isModalContext,
}) => {
    const canAddToList = showAddToList && productContext.product.canAddToWishlist; // Starter Custom Code

    return (
        <StyledWrapper {...styles.wrapper}>
            {showPrice && (
                <StyledWrapper {...styles.priceWrapper /* Starter Custom Code */}>
                    <ProductPrice
                        product={productContext}
                        showLabel={false}
                        showSavings={true}
                        showSavingsAmount={productSettings.showSavingsAmount}
                        showSavingsPercent={productSettings.showSavingsPercent}
                        extendedStyles={styles.price}
                    />
                    <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />
                </StyledWrapper>
            )}
            <AddToCartOptionsAndButton
                extendedStyles={{
                    ...styles.addToCartOptionsAndButton,
                    unitOfMeasure: {
                        ...styles.addToCartOptionsAndButton?.unitOfMeasure,
                        uid: `uom-${productContext.product.id}`,
                    },
                    quantityOrdered: {
                        ...styles.addToCartOptionsAndButton?.quantityOrdered,
                        id: `qty-ordered-${productContext.product.id}`,
                    },
                    addToCartButton: {
                        ...styles.addToCartOptionsAndButton?.addToCartButton,
                        "data-test-selector": `actionsAddToCart${productContext.product.id}`,
                    },
                }}
                /* Store Custom Code - Start */
                isModalContext={isModalContext}
                /* Store Custom Code - End */
            />
            {canAddToList /* Starter Custom Code */ && (
                <StyledWrapper {...styles.addToListWrapper}>
                    <ProductAddToListLink
                        data-test-selector={`actionsAddToList${productContext.product.id}`}
                        extendedStyles={styles.addToListLink}
                    />
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(ProductListActions));
